export const BLOCK = 'co-item'
export const LINKTO = window.location.host === 'www.asda.com' ? 'https://groceries.asda.com' : 'https://groceries-qa.asda.com'
export const fsl = `${BLOCK}-fsl`
export const UNAVAILABLE_BLOCK = 'unavailable-banner'
export const PILL_BLOCK = 'asda-pill'



// WEBPACK FOOTER //
// ./shared/interim/product-list/item/constants.js